module.exports = __webpack_public_path__ + "media/src/images/course-page-card_image-43de25c80ec899b469df545437308b61.png";